export const formatPhoneNumber = (value: string) => {
  const phoneNumber = value.replace(/[^\d]/g, '')

  // DDD + 9 dígitos
  if (phoneNumber.length === 11) {
    return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }
}
